import { Dialog, Button } from "@mui/material";
import baseURL from "../../../../configs/api";
import { useTheme } from "../../../../components/hooks/useTheme";
import useDelete from "../../../../components/hooks/useDelete";
import colorConfigs from "../../../../configs/colorConfigs";
import useAuth from "../../../../components/hooks/useAuth";
import Cookies from "js-cookie";
import useTenant from "../../../../components/hooks/useTenant";

type Props = {
    editPopup: boolean;
    hidePopup: () => void;
    deleteCreditCard: () => void;
    particularCreditDetails: any;
}

export default function DeleteCreditCard({ editPopup, hidePopup, deleteCreditCard, particularCreditDetails }: Props) {
    const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
    const { auth }: any = useAuth();
    const { handleTenantError }: any = useTenant();
    const { themeStyles } = useTheme();
    const { setDeletePopup, setData: setDeleteData }: any = useDelete();

    const deleteTheCreditCard = () => {
        setDeleteData({
            tilte: `Delete`,
            summary: `Are you sure you want to delete this Credit Card?`,
            isDelete: (callback: any) => {
                fetch(`${baseURL}creditCard?id=${particularCreditDetails?.id}&userId=${auth?.id}`, {
                    method: 'DELETE',
                    headers: {
                        'X-Tenant-ID': tenantId,
                    }
                })
                    .then(() => {
                        deleteCreditCard();
                        callback();
                        handleTenantError(null);
                    })
                    .catch((error) => {
                        callback();
                        handleTenantError(error);
                    });
            }
        });

        setDeletePopup(true);
    };

    return (
        <>
            <Dialog
                open={editPopup}
                sx={{
                    '& .MuiDialog-paper': {
                        maxWidth: '800px',
                        width: '100%',
                        borderRadius: '16px',
                    },
                }}
            >
                <div className={`px-[24px] py-[10px] h-full ${themeStyles.main.tailwindSectionBg}`}>
                    <div className={`w-full bg-transparent rounded-lg p-[10px] flex flex-col gap-2.51`}>
                        <div className="w-full mt-2">
                            <div className={`w-full`}>
                                <div className={`sticky top-0 z-10 flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor} ${themeStyles.main.tailwindSectionBg}`}>
                                    <div className="flex items-center gap-1.5">
                                        <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Credit Card Info</h2>
                                    </div>

                                    <button
                                        onClick={hidePopup}
                                        className="absolute right-2 top-2 text-gray-500 hover:text-red-500 transition"
                                    >
                                        <span className="material-symbols-outlined text-[20px]">close</span>
                                    </button>
                                </div>


                                <div className="mt-2 p-2">
                                    <div className="w-full">
                                        <div className="grid grid-cols-2 gap-6">
                                            <div className="space-y-4">
                                                <div className="flex flex-col gap-1.5">
                                                    <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Last 4 digits</span>
                                                    <span className={`text-sm ${themeStyles.main.textSubHeadingColor}`}>....{particularCreditDetails?.creditCardNumber}</span>
                                                </div>

                                                <div className="flex flex-col gap-1.5">
                                                    <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Contact</span>
                                                    <span className={`text-sm ${themeStyles.main.textSubHeadingColor}`}>{particularCreditDetails?.contact}</span>
                                                </div>

                                                <div className="flex flex-col gap-1.5">
                                                    <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Brand</span>
                                                    <span className={`text-sm ${themeStyles.main.textSubHeadingColor}`}>{particularCreditDetails?.brand}</span>
                                                </div>
                                            </div>

                                            <div className="space-y-4">
                                                <div className="flex flex-col gap-1.5">
                                                    <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Expiration Date</span>
                                                    <span className={`text-sm ${themeStyles.main.textSubHeadingColor}`}>{particularCreditDetails?.expirationDate}</span>
                                                </div>

                                                <div className="flex flex-col gap-1.5">
                                                    <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Cardholder's Name</span>
                                                    <span className={`text-sm ${themeStyles.main.textSubHeadingColor}`}>{particularCreditDetails?.cardholderName}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className={`sticky bottom-0 flex justify-start gap-4 p-4 ${themeStyles.main.tailwindSectionBg} z-10`}>
                                            <Button
                                                variant="contained"
                                                sx={{
                                                    backgroundColor: colorConfigs.btn.cancel.bg,
                                                    border: colorConfigs.btn.cancel.border,
                                                    color: colorConfigs.btn.cancel.color

                                                }}
                                                onClick={hidePopup}
                                            >
                                                Close
                                            </Button>

                                            <Button variant="contained"
                                                sx={{
                                                    backgroundColor: colorConfigs.btn.delete.bg,
                                                }}
                                                onClick={deleteTheCreditCard}
                                            >
                                                Delete
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
        </>
    )
}
